import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../models/error.model';
import { IMainApiService } from '../../../../../services/api.service';
import { IApiService } from '../../../../../services/api.service.base';
import { IQuestionModel } from '../../../../annotation/question.model';
import { ImageSelectionMode, ImageSetType } from '../projectDetailsImages.model';

interface IBatchAnswerQuestionsRequest {
  projectId: string;
  filterId: string;
  toggledImages: string[];
  selectionMode: ImageSelectionMode;
  questions: IQuestionModel[];
  sessionId: string;
}

export interface IUpdateProjectImageSetRequest {
  projectId: string;
  filterId: string;
  toggledImages: string[];
  selectionMode: ImageSelectionMode;
  projectImageSet: ImageSetType;
}

interface IGetQuestionsRequest {
  projectId: string;
}

export interface IProjectDetailsImagesApiService {
  batchAnswerQuestionsAsync(request: IBatchAnswerQuestionsRequest): Promise<void | ACDLError>;
  updateProjectImageSetAsync(request: IUpdateProjectImageSetRequest): Promise<void | ACDLError>;
  getQuestions(request: IGetQuestionsRequest): Promise<IQuestionModel[] | ACDLError>;
}

export namespace IProjectDetailsImagesApiService {
  export const $: interfaces.ServiceIdentifier<IProjectDetailsImagesApiService> = Symbol('PROJECT_DETAILS_IMAGES_API_SERVICE');
}

@injectable()
export class ProjectDetailsImagesApiService implements IProjectDetailsImagesApiService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  async getQuestions(request: IGetQuestionsRequest): Promise<IQuestionModel[] | ACDLError> {
    return await this.apiService.getAsync<IQuestionModel[]>('/Questions/GetBatchAnswerQuestions', { params: request });
  }

  async batchAnswerQuestionsAsync(request: IBatchAnswerQuestionsRequest): Promise<void | ACDLError> {
    return await this.apiService.postAsync('/Annotation/BatchAnswerQuestions', request);
  }

  async updateProjectImageSetAsync(request: IUpdateProjectImageSetRequest): Promise<void | ACDLError> {
    return await this.apiService.postAsync('/Projects/UpdateProjectImagesSet', request);
  }
}
